import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modale-logout',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="modal-card">
      <div class="modal-icon modal-icon-warning">
        <i class="bi bi-box-arrow-right"></i>
      </div>
      <div class="modal-title">Logout</div>
      <div class="modal-subtitle">Sei sicuro di voler uscire dall'applicazione?</div>
      
      <div class="d-flex gap-2">
        <button class="btn btn-outline-secondary w-100" (click)="activeModal.close(false)">Annulla</button>
        <button class="btn btn-danger w-100" ngbAutofocus (click)="activeModal.close(true)">Logout</button>
      </div>
    </div>
  `
})
export class ModaleLogoutComponent {
  activeModal = inject(NgbActiveModal);
}
